let _ = require("ES/lib/lodash");
let getSpeakersFromDisplaylists = require("./getSpeakersFromDisplaylists");
let AuthedUserSession = require("./AuthedUserSession");

module.exports = function (Displaylists, sids, company_id = null) {
  let common_actionlist_sid = _.get(
    Displaylists,
    "universal.USE_COMMON_ACTIONLISTS_SID"
  );
  let my_speakers = getSpeakersFromDisplaylists(
    Displaylists,
    sids,
    common_actionlist_sid
  );

  if (AuthedUserSession.is_st_family) {
    //TEAM-ADMIN privatelabels using only common actionlists
    let r = _.get(
      Displaylists,
      ["universal", "todolists", company_id, "lists"],
      []
    );
    r = _.map(r, function (todolist) {
      return [todolist.id, todolist.listname];
    });
    r = _.object(r);
    return r;
  } else {
    //normal, per-speaker actionlists combined with shared lists
    let r = _.flatten(
      _.map(my_speakers, function (spkr) {
        return _.map(_.get(spkr, ["todolists"]), function (todolist) {
          return [
            _.get(todolist, ["id"]),
            _.get(todolist, ["listname"]) +
              (_.get(spkr, ["sid"]) === common_actionlist_sid
                ? " (shared)"
                : ""),
          ];
        });
      })
    );
    let shared = _.map(
      _.get(Displaylists, ["universal", "todolists", company_id, "lists"], []),
      function (todolist) {
        return [
          _.get(todolist, ["id"]),
          _.get(todolist, ["listname"]) + " (shared)",
        ];
      }
    );
    r = _.object(_.union(r, shared));
    return r;
  }
};



// WEBPACK FOOTER //
// ./src/utils/getActionListDropDownOptions.js